import React from 'react';
import { useTheme, useMediaQuery, Typography, Box } from '@mui/material';
import Background from '../../assets/img/background.webp';
import BackgroundMobile from '../../assets/img/backgroundMobile.webp';
import StefaniniLongLogo from '../../assets/img/Stefanini_logo_white.webp';
import { ColorPalette, TypographyFamily } from '../../styles/constants';

interface Props {
  header: string;
  paragraph?: string;
}

const makeStyles = (isMobile: boolean) => ({
  topBox: {
    backgroundImage: isMobile
      ? `url(${BackgroundMobile})`
      : `url(${Background})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  container: {
    backgroundColor: 'rgba(51, 46, 56, 0.6);',
    width: '100vw',
    height: '100vh',
    p: isMobile ? '38px 20px 38px 20px' : '75px 100px 75px 100px',
    position: 'relative',
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    maxWidth: 800,
  },
  header: {
    color: ColorPalette.WHITE,
    fontFamily: TypographyFamily.ARIAL,
    fontWeight: 700,
    fontSize: isMobile ? '48px' : '64px',
    lineHeight: isMobile ? '55.2px' : '73.59px',
    mb: '20px',
  },
  paragraph: {
    color: ColorPalette.WHITE,
    fontFamily: TypographyFamily.ARIAL,
    fontWeight: 400,
    fontSize: isMobile ? '16px' : '20px',
    lineHeight: isMobile ? '18.4px' : '30px',
    maxWidth: 500,
  },
  topLogo: {
    display: isMobile ? 'none' : 'flex',
    position: 'fixed',
  },
  bottomLogo: {
    display: isMobile ? 'flex' : 'none',
    justifyContent: 'center',
    position: 'relative',
    bottom: '38px',
  },
});

export function PreAuthentificationPage({
  header,
  paragraph,
}: Props): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const style = makeStyles(isMobile);

  return (
    <Box sx={style.topBox}>
      <Box sx={style.container}>
        <Box sx={style.topLogo}>
          <img src={StefaniniLongLogo} className="stefaniniLogoPreAuthTop" />
        </Box>
        <Box sx={style.textBox}>
          <Typography sx={style.header}>{header}</Typography>
          <Typography sx={style.paragraph}>{paragraph}</Typography>
        </Box>
        <Box sx={style.bottomLogo}>
          <img src={StefaniniLongLogo} className="stefaniniLogoPreAuthBottom" />
        </Box>
      </Box>
    </Box>
  );
}
